import { LineShopProductsEventPayload } from '@/methods/lineshop/types'

import { getLineShopTrackingClient } from './client'

const ENDPOINT = '/v1/lineshop/tracking/events/products'

export const sendProductsEvent = (payload: LineShopProductsEventPayload) => getLineShopTrackingClient().post(ENDPOINT, payload)
